'use strict';

var pull = require('pull-stream/pull');

var collect = require('pull-stream/sinks/collect');

var readPullStream = require('./read-pull-stream');

module.exports = function (ipfs) {
  return function mfsRead(path, options, callback) {
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }

    pull(readPullStream(ipfs)(path, options), collect(function (error, buffers) {
      if (error) {
        return callback(error);
      }

      return callback(null, Buffer.concat(buffers));
    }));
  };
};